module.exports = __webpack_public_path__ + "img/cl2_1.11972a2a.png";